<script>
import navegacion from './elements/Navegacion.vue'
import articulosQuicktable from '../Concepts/Articulos/quicktable.vue'
export default {
    name: 'CatalogosArticulos',
    components: { navegacion, articulosQuicktable },
    methods: {
        catLoaded() {
            if (!!this.$refs && !!this.$refs.nutricionales) {
                this.$refs.nutricionales.refresh()
            }
        }
    }
}
</script>

<template>
    <div id="CatalogosArticulos">
        <navegacion class="mb-4"/>
        <articulos-quicktable />
    </div>
</template>